'use client';

import type { PropsWithChildren } from 'react';
import { FormProvider } from 'react-hook-form';

import { usePurchaseForm } from '../model';

type PurchaseFormProps = PropsWithChildren;

export const PurchaseForm = ({ children }: PurchaseFormProps) => {
    const { submitHandler, ...form } = usePurchaseForm();

    return (
        <FormProvider {...form}>
            <form
                className="purchase-form"
                onSubmit={submitHandler}
                id="pdp-purchase-form"
                data-testid="pdp-purchase-form"
            >
                {children}
            </form>
        </FormProvider>
    );
};
